import React from "react";

import store from "./store";

import OrdersRequest from "./behaviors/OrdersRequest";
import Widget from "./components/Widget";
import TransitionToNextOrder from "./behaviors/TransitionToNextOrder";
import ToggleWidgetVisibility from "./behaviors/ToggleWidgetVisibility";

class App extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      store
    };

    this.onChange = this.onChange.bind(this);
  }

  componentDidMount() {
    store.subsribe(this.onChange);
  }

  componentWillUnmount() {
    store.unsubsribe(this.onChange);
  }

  onChange() {
    this.setState({ store });
  }

  render() {
    return <Widget />;
  }
}

const AppContainer = () => (
  <React.Fragment>
    <OrdersRequest />
    <TransitionToNextOrder />
    <ToggleWidgetVisibility />

    <App />
  </React.Fragment>
);

export default AppContainer;
